import { find } from 'lodash/fp'
import React from 'react'

interface MenuItems<T> {
  value: T
  text: string
}

export const useMuiSelectUtils = <T extends unknown>(data: MenuItems<T>[], selected: string) => {
  const [selectedItem, setSelectedItem] = React.useState(selected)
  const getItem = React.useCallback((id: string) => find((m) => m.value === id, data), [selected])

  return {
    getItem,
    setSelectedItem,
    selectedItem,
  }
}
